import { POSITION_FRAGMENT } from 'apollo/queries/position-queries';
import gql from 'graphql-tag';

export const POSITION_CREATE_MUTATION = gql`
  mutation CreatePosition($position: PositionCreateInput) {
    createPosition(position: $position) {
      ...PositionDetails
    }
  }
  ${POSITION_FRAGMENT}
`;

export const POSITION_UPDATE_MUTATION = gql`
  mutation UpdatePosition($position: PositionUpdateInput) {
    updatePosition(position: $position) {
      ...PositionDetails
    }
  }
  ${POSITION_FRAGMENT}
`;
